export const tasksLoading = (state) => state.tasks.loading;
export const tasksData = (state) => state.tasks.data;
